import { logger } from '@/shared/helpers/logger';
import { toArchive, toVersionManifest } from '@/viewmodel/shared/versionCheck/mappers/releaseNotes';
import type { AnnouncementArchive, VersionManifest } from '@/viewmodel/shared/versionCheck/types';

async function fetchJson(path: string): Promise<unknown> {
  const response = await fetch(`${path}?t=${Date.now()}`, { cache: 'no-store' });
  if (!response.ok) return null;
  return response.json() as Promise<unknown>;
}

export async function fetchVersionManifest(): Promise<VersionManifest | null> {
  try {
    return toVersionManifest(await fetchJson('/version.json'));
  } catch (error) {
    logger.warn('versionApi: failed to fetch version manifest', {
      log_source: 'versionApi',
      error,
    });
    return null;
  }
}

export async function fetchAnnouncements(): Promise<AnnouncementArchive | null> {
  try {
    return toArchive(await fetchJson('/release-notes.json'));
  } catch (error) {
    logger.warn('versionApi: failed to fetch announcements', { log_source: 'versionApi', error });
    return null;
  }
}
